module.exports = __webpack_public_path__ + "static/img/phone.39065e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1